import {
    AppPageUrl,
    CampaignUrl,
    DashboardUrl,
    EditCampaignUrl,
    LogoutPageUrl,
    MobilePageUrl,
    ReportUrl,
    rootPageUrl,
    UsersPageUrl
} from "@common";
import { AppPage, CampaignPage, DashboardPage, LogInPage, MobilePage, ReportPage, UsersPage } from "@pages";
import { browserHistory, store } from "@store";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { ConnectedRouter as Router } from "react-router-redux";
import "../config.json";
import "./styles/common-classes.css";
import "./styles/common-components.css";
import "./styles/common.css";
import "./styles/brand.css";

ReactDOM.render(
    <Provider store={store}>
        <Router history={browserHistory}>
            <Switch>
                <Route exact path={rootPageUrl.urlTemplate} component={LogInPage} />
                <Route exact path={AppPageUrl.urlTemplate} component={AppPage} />
                <Route exact path={MobilePageUrl.urlTemplate} component={MobilePage} />
                <Route exact path={LogoutPageUrl.urlTemplate} component={DashboardPage} />
                <Route exact path={DashboardUrl.urlTemplate} component={DashboardPage} />
                <Route exact path={CampaignUrl.urlTemplate} component={CampaignPage} />
                <Route exact path={EditCampaignUrl.urlTemplate} component={CampaignPage} />
                <Route exact path={ReportUrl.urlTemplate} component={ReportPage} />
                <Route exact path={UsersPageUrl.urlTemplate} component={UsersPage} />
            </Switch>
        </Router>
    </Provider>,
    document.getElementById("root")
);
